import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

import { Router } from '@angular/router';
import { UserProfile } from '../raintree/interfaces/user-profile';
import { RequestMapper } from '../../request-mapper';
import { CommonUtilService } from '../common-util/common-util.service';
import { ApiService } from '../common/api.service';
import { ROUTES } from '../server-route';
import { map, Observable, switchMap, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public isBrowser: boolean = false;
  private timerInterval: any;
  private tokenRefreshedCount: number = 0;
  private accessToken: string | null = null;

  constructor(
    private _commonUtilService: CommonUtilService,
    private _router: Router,
    private apiService: ApiService,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private _platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this._platformId);
  }

  public storeJwtTokenInLocalStorage(loginRes: any): void {
    // No permissions ?
    if (!loginRes.permissionsV2) {
      throw `You don't have any Permissions, please contact Admin: stsngofc.itwing@gmail.com`;
    }

    console.log('loginRes', loginRes);

    // token
    localStorage.setItem('AccessToken', loginRes.accessToken);

    // other local storage info
    // localStorage.setItem('permissions', loginRes.permissions);
    localStorage.setItem('fullName', loginRes.fullName);
    localStorage.setItem('district', loginRes.district);
    localStorage.setItem('pincode', loginRes.pinCode);
    localStorage.setItem('state', loginRes.state);
    localStorage.setItem('role', loginRes.role);
    localStorage.setItem('userId', loginRes.userId);
    localStorage.setItem('permissions', btoa(encodeURIComponent(JSON.stringify(loginRes.permissionsV2))));
    localStorage.setItem('permissionsV1', loginRes.permissions);
    localStorage.setItem(
      'permissionsV3',
      btoa(encodeURIComponent(JSON.stringify(loginRes.permissionsV3)))
    );
    // this._commonUtilService.setDataToLocalStore('AccessToken', jwtToken);

    // session timer start
    localStorage.setItem('familyCode', loginRes.familyCode);
    this.initTimer();
  }

  public logOut() {
    const isRememberMe: boolean = localStorage.getItem('rememberMe') === 'true'
    if(isRememberMe){
    this.LoggedOut().subscribe({
      next: (res) =>{
        if (res) {
          this._router.navigate([RequestMapper.LOGIN]);
          localStorage.clear();
          this.clearTimer();

        }
      }
    })
  }else{
      this._router.navigate([RequestMapper.LOGIN]);
          localStorage.clear();
          this.clearTimer();
  }
  }

  private LoggedOut(): Observable<any>{
    return this.http.post(ROUTES.LOG_OUT, {}, {withCredentials: true})
  }

  public signInAuth(body: any): Observable<any>{
     return this.http.post(ROUTES.SIGNIN, body, {withCredentials: environment.production})
  }

  public prepareLoginProcess(userProfileData: UserProfile): void {
    this._setProfileInformationInLocalStorage(userProfileData);

    if (this.isBrowser) {
      // localStorage.setItem('isLoggedIn', 'true');
      this._commonUtilService.setDataToLocalStore('isLoggedIn', true);
      // localStorage.setItem('role', JSON.stringify(userProfileData.roles));
      this._commonUtilService.setDataToLocalStore('role', 'FO,accountant'); //TODO: for testing
      this._router.navigate([RequestMapper.DASHBOARD]);
    }
  }

  private _setProfileInformationInLocalStorage(
    userProfileData: UserProfile
  ): void {
    // console.log(jwtToken);
    this._commonUtilService.setDataToLocalStore('userProfile', userProfileData);
  }

  public initTimer() {
    try {
      this.clearTimer();
      const accessToken = localStorage.getItem('AccessToken');
      if (typeof accessToken !== 'undefined' && accessToken) {
        const accessTokenSplit = accessToken.split('.');
        const accessPayloadPart = accessTokenSplit[1];
        const decodedPayload = JSON.parse(window.atob(accessPayloadPart));
        const tokenExpiryTimestamp = decodedPayload.exp;
        const timeRemainingInSeconds = Math.round((new Date(tokenExpiryTimestamp)).getTime() - ((new Date()).getTime() / 1000));
        this.apiService.tokenExpiresInSecond.next(timeRemainingInSeconds);
        this.timerInterval = setInterval(() => {
          this.apiService.tokenExpiresInSecond.next(this.apiService.tokenExpiresInSecond.getValue() - 1);
        }, 1000);
      }
    } catch (e) {
      console.error('initTimer ERROR: ', e);
    }
  }

  public clearTimer() {
    clearInterval(this.timerInterval);
  }

  public renewAccessToken() {
    if (this.tokenRefreshedCount <= 6) {
      this.apiService
        .get<{ accessToken: string }>(ROUTES.REFRESH_TOKEN)
        .subscribe({
          next: (response: any) => {
            // console.log('REFRESH');
            this.tokenRefreshedCount++;
            this.storeJwtTokenInLocalStorage(response.data);
          },
          error: (error) => {
            throwError(() => error);
          }
        });
    }
  }

   setAccessToken(token: string): void {
    localStorage.setItem('AccessToken', token)
    this.accessToken = token;
    // Optionally also persist to memory / sessionStorage
  }

   getAccessToken(): string | null {
    return this.accessToken;
  }

  checkRememberMe(){
    const isRememberMe = Boolean(localStorage.getItem('rememberMe'))
    isRememberMe ? this.refreshAccessToken() : this.renewAccessToken()
  }

  public refreshAccessToken(refreshToken?: string): Observable<string> {
    return this.http
      .post<any>(ROUTES.REFRESH_ACCESS_TOKEN, {}, {withCredentials: true})
      .pipe(map((res) => res.data.accessToken),
            // unwrap so interceptor receives a plain string
            // switchMap(res => of(res.accessToken))  ← if needed
      );
  }
}
